import { VerifyEmailErrorResponse } from '@src/api/company/profile/companyProfileApiClient';
import { VerifyFormValues } from '@src/features/company/profile/ProfileForm';
import Modal from '@src/layouts/Modal';
import Button from '@src/ui/elements/button/Button';
import ErrorMessage from '@src/ui/elements/form/ErrorMessage';
import Input from '@src/ui/elements/form/Input';
import { firstError, hasError } from '@src/utils/errorMessageUtils';
import React from 'react';

interface VerifyEmailModalProps {
  verifyValues: VerifyFormValues;
  onVerifyValuesChange: (value: Partial<VerifyFormValues>) => void;
  onVerify: () => void;
  onClose: () => void;
  isOpen?: boolean;
  errors?: VerifyEmailErrorResponse;
}

const VerifyEmailModal: React.FC<VerifyEmailModalProps> = ({
  verifyValues,
  onVerifyValuesChange,
  onVerify,
  onClose,
  isOpen = true,
  errors,
}) => {
  return (
    <React.Fragment>
      {isOpen && (
        <div className='h-[120vh]'>
          <Modal width='500px'>
            <div className='flex grow flex-col gap-8 px-8 py-10'>
              <div className='border-b border-b-gray-350 pb-4'>
                <h2 className='text-lg font-semibold'>確認コード（6桁）を送信してください</h2>
              </div>

              <div className='whitespace-pre-wrap'>
                <strong>メールアドレスはまだ変更されていません。</strong>
                <br />
                変更後のメールアドレスに届いた確認コード（6桁）とログインパスワードを入力してください。
              </div>

              <div className='flex flex-col gap-[6px]'>
                <div className='flex items-center gap-3'>
                  <label className=''>確認コード（6桁）</label>
                </div>
                <div className='flex gap-4'>
                  <div className='flex w-full flex-col gap-2'>
                    <Input
                      size='m'
                      type='text'
                      placeholder='123456'
                      value={verifyValues.code}
                      error={hasError(errors?.code)}
                      onChange={(e) => onVerifyValuesChange({ code: e.target.value })}
                      autoComplete='one-time-code'
                    />
                    <ErrorMessage>{firstError(errors?.code)}</ErrorMessage>
                  </div>
                </div>
              </div>
              <div className='flex flex-col gap-[6px]'>
                <div className='flex items-center gap-3'>
                  <label className=''>ログインパスワード</label>
                </div>
                <div className='flex gap-4'>
                  <div className='flex w-full flex-col gap-2'>
                    <input
                      id='password'
                      type='password'
                      className={`input-login ${hasError(errors?.password) ? `error-input` : ``}`}
                      placeholder='現在のパスワード'
                      onChange={(e) => onVerifyValuesChange({ password: e.target.value })}
                    />
                    <ErrorMessage>{firstError(errors?.password)}</ErrorMessage>
                  </div>
                </div>
              </div>
              <div className='mt-auto flex w-full justify-center gap-5'>
                <ErrorMessage>{firstError(errors?.messages)}</ErrorMessage>
              </div>
              <div className='mt-auto flex w-full justify-center gap-5'>
                <div>
                  <Button
                    variant='secondary'
                    fullRounded
                    fullWidth
                    outline
                    onClick={onClose}
                  >
                    取消
                  </Button>
                </div>
                <div>
                  <Button
                    fullRounded
                    fullWidth
                    onClick={onVerify}
                  >
                    送信
                  </Button>
                </div>
              </div>
            </div>
          </Modal>
        </div>
      )}
    </React.Fragment>
  );
};

export default VerifyEmailModal;
